import { render } from "./ChatView.vue?vue&type=template&id=9e053400&scoped=true&ts=true"
import script from "./ChatView.vue?vue&type=script&lang=ts"
export * from "./ChatView.vue?vue&type=script&lang=ts"

import "./ChatView.vue?vue&type=style&index=0&id=9e053400&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e053400"]])

export default __exports__